import type { TourBasicInfoState } from '@/shared/api/types/tour-types'
import { useTranslation } from 'react-i18next'
import { TourScopeFields } from '@/features/tour/tour-scope-fields'
import { cn } from '@/shared/libs/cn'
import { FormSectionCard } from '@/shared/ui/form-section-card'
import { SectionSaveButton } from '@/shared/ui/section-save-button'

interface SelectOption {
  label: string
  value: string
}

interface ScopeCardProps {
  isEdit: boolean
  isFormReady: boolean
  basicInfo: TourBasicInfoState
  onChange: (value: TourBasicInfoState) => void
  countryOptions: SelectOption[]
  provinceOptions: SelectOption[]
  tenantDestinationOptions: SelectOption[]
  isProvinceLoading: boolean
  isTenantDestinationLoading: boolean
  onCreateDestination: () => void
  isDirty: boolean
  isSaving: boolean
  isUpdating: boolean
  onSave: () => void
}

/** Country → province → destination of the tour; the destination decides which POIs can be picked next. */
export function ScopeCard({
  isEdit,
  isFormReady,
  basicInfo,
  onChange,
  countryOptions,
  provinceOptions,
  tenantDestinationOptions,
  isProvinceLoading,
  isTenantDestinationLoading,
  onCreateDestination,
  isDirty,
  isSaving,
  isUpdating,
  onSave,
}: ScopeCardProps) {
  const { t } = useTranslation()

  return (
    <FormSectionCard
      title={t('tour.scope', { defaultValue: 'Phạm vi & điểm đến' })}
      action={
        isEdit && (
          <SectionSaveButton disabled={isUpdating || !isDirty} saving={isSaving} onSave={onSave} />
        )
      }
    >
      <div className={cn(!isFormReady && 'pointer-events-none opacity-50')}>
        <TourScopeFields
          value={basicInfo}
          countryOptions={countryOptions}
          provinceOptions={provinceOptions}
          tenantDestinationOptions={tenantDestinationOptions}
          isProvinceLoading={isProvinceLoading}
          isTenantDestinationLoading={isTenantDestinationLoading}
          onCreateDestination={onCreateDestination}
          onChange={onChange}
        />
      </div>
    </FormSectionCard>
  )
}
